var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 182",
    x: 1,
    y: 1,
    width: 6,
    height: 6,
    fill: "#A5B1AA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 185",
    x: 1,
    y: 9,
    width: 6,
    height: 6,
    fill: "#A5B1AA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 188",
    x: 1,
    y: 17,
    width: 6,
    height: 6,
    fill: "#A5B1AA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 183",
    x: 9,
    y: 1,
    width: 6,
    height: 6,
    fill: "#A5B1AA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 186",
    x: 9,
    y: 9,
    width: 6,
    height: 6,
    fill: "#A5B1AA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 189",
    x: 9,
    y: 17,
    width: 6,
    height: 6,
    fill: "#A5B1AA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 184",
    x: 17,
    y: 1,
    width: 6,
    height: 6,
    fill: "#A5B1AA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 187",
    x: 17,
    y: 9,
    width: 6,
    height: 6,
    fill: "#A5B1AA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 190",
    x: 17,
    y: 17,
    width: 6,
    height: 6,
    fill: "#A5B1AA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid_icon.4207bad822ab343807a2956024db764f.svg";
export { ForwardRef as ReactComponent };